import { useState } from 'react';

import { ThemaFromThemaRouter } from '../../../dtos';
import { getPendantLabel, isOnlineAndOrPraesenz } from '../../../utils/isOnline';

export const useOnlinePraesenzFilter = (thema: ThemaFromThemaRouter, linkedThema?: ThemaFromThemaRouter) => {
  const [selectedOptions, setSelectedOptions] = useState([thema.akaProduktId]);
  const isFullyOnline = isOnlineAndOrPraesenz(thema.isOnline, thema.planungsformat, thema.module) === 'ONLINE';

  const allOptions = [
    {
      label: isFullyOnline ? 'Online' : 'Präsenz',
      value: thema.akaProduktId,
    },
  ];
  if (linkedThema) {
    allOptions.push({
      label: getPendantLabel(linkedThema),
      value: linkedThema.akaProduktId,
    });
  }

  const toggleOption = (clickedOption: string) => {
    setSelectedOptions((prev) =>
      prev.includes(clickedOption) ? prev.filter((option) => option !== clickedOption) : [...prev, clickedOption],
    );
  };

  return { allOptions, selectedOptions, toggleOption };
};
